<template>
  <div>
    <el-popover v-model="visible" placement="top" width="300" title="輸出目前條件資料到EXCEL">
      <el-input v-model="customFileName" :placeholder="placeholder" prefix-icon="el-icon-document" class="mb-2" />
      <div style="text-align: right; margin: 0" v-loading="is_loading">
        <el-button size="medium" type="text" @click="visible = false">取消</el-button>
        <el-button type="success" size="medium" @click="downloadExcel"> 儲存EXCEL </el-button>
      </div>
      <el-button slot="reference" type="primary">輸出EXCEL</el-button>
    </el-popover>
  </div>
</template>
<script>
import { v2GetSalesCsv } from '@/api/transaction';
const dayjs = require('dayjs');
const methods = {
  clearFilename() {
    this.customFileName = '';
  },
  async downloadExcel() {
    try {
      this.is_loading = true;
      const response = await fetch(this.excel_url);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      if (this.customFileName !== '') {
        link.download = `${this.customFileName}.csv`;
      } else {
        link.download = `銷售紀錄-${dayjs().format('YYYYMMDD-HHmmss')}.csv`;
      }
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      this.$message({
        message: '下載失敗',
      });
    } finally {
      this.is_loading = false;
    }
  },
  clearData() {
    this.$emit('clearData');
    this.is_loading = true;
  },
};
export default {
  watch: {
    async visible(val) {
      console.log(val);
      if (!val) {
        this.clearFilename();
        return;
      }
      try {
        this.is_loading = true;
        const tmpName = `${dayjs().format('YYYYMMDDHHmmss')}.csv`;
        const res = await v2GetSalesCsv(
          this.condition,
          {
            size: 9999999,
            page: 1,
          },
          this.sale_ordering,
          -1,
          tmpName,
        );
        console.log(res);
        const real_base_url = process.env.VUE_APP_BASE_API.replace('/adminapi', '');
        // const real_base_url = process.env.VUE_APP_BASE_API;
        this.excel_url = `${real_base_url}/public${res.url}`;
        console.log(this.excel_url);
        this.is_loading = false;
      } catch (error) {
        console.error('onExportClick error', error);
      }
    },
  },
  async mounted() {
    console.log(this.condition);
  },
  props: {
    condition: {
      type: Object,
      default: () => {
        return {};
      },
    },
    sale_ordering: {
      type: Object,
      default: () => {
        return { prop: 'SaleTime', order: 'DESC' };
      },
    },
    filename: {
      type: String,
      default: 'sales.csv',
    },
  },
  data() {
    return {
      customFileName: '',
      visible: false,
      is_loading: true,
      excel_url: '',
    };
  },
  computed: {
    placeholder() {
      return '請輸入檔案名稱 (預設檔名為現在時間)';
    },
  },
  methods,
};
</script>
<style>
button {
  background: rgba(255, 255, 255, 0);
  border: 0;
}
</style>
